import { lazy } from '@loadable/component';

const SystemSettingsPage = lazy(() => import('./SystemSettingsPage'));

export default SystemSettingsPage;
